import React from 'react';

const VazhibaduSevas = () => (
  <div className="max-w-4xl mx-auto mt-12">
    <div className="card-temple">
      <h3 className="text-2xl font-bold text-saffron mb-6 text-center">
        Vazhipadu/Sevas
      </h3>
      <div className="text-center py-8">
        <p className="text-lg text-gray-600 mb-6">
          Participate in our special temple sevas and offerings.
        </p>
        
        <div className="flex flex-col space-y-4 items-center">
          <button
            onClick={() => {
              window.open("https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/6n22zrqq_The%20offering%20of%20Laddu%20Seva%20%28laddu%20offering%29%20is%20very%20famous%20as%20the%20favorite%20_20250929_225231_0000.pdf", '_blank', 'noopener,noreferrer');
            }}
            className="btn-temple w-full md:w-auto"
            data-testid="laddu-seva-btn"
          >
            Laddu Seva Details (PDF)
          </button>
          
          <p className="text-base font-bold text-black text-center">
            The amount for laddu seva is Rs 700/- with Besan laddu Rs 8/- per laddu and Boondi Laddu Rs 9/- per laddu (for Aarattu Mahotsavam 2026).
          </p>
          
          <button
            onClick={() => {
              window.open("https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/552orx9f_Enna%20vilakku%20Ney%20vilakku%20Naruney%20%28%20Sree%20kovil%20%29%20Nirmaalya%20Aarti.pdf", '_blank', 'noopener,noreferrer');
            }}
            className="btn-temple w-full md:w-auto"
            data-testid="vazhipadu-sevas-btn"
          >
            Vazhipadu/Sevas Details (PDF)
          </button>
          
          <p className="text-sm text-gray-600 font-bold mt-2">
            The Vazhipadu/Sevas section has been updated as of 17th August 2026, the seva amounts may change as per the material costs. Kindly confirm the rates with the management in the future.
          </p>
        </div>
        
        <div className="mt-8 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/rf2xedak_1000008843.png"
            alt="Pooja timings and facilities information"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
        
        <p className="text-sm text-gray-500 mt-4">
          Please contact the temple directly for information about other special offerings and ceremonies.
        </p>
        
        <div className="mt-8 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/9ks85k0k_Your%20paragraph%20text.png"
            alt="Vazhipadu Sevas information"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
        
        <div className="mt-8 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/ammfoozi_Samooha%20Unjal%20Seva%20Dear%20Devotees%2C%20If%20youbwish%20to_20251211_133624_0000.png"
            alt="Samooha Unjal Seva"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
        
        <div className="mt-8 text-center">
          <img
            src="https://customer-assets-m6fa6gv7.emergentagent.net/job_6b23d131-7c65-4566-a2b5-504887f6a0cf/artifacts/4mwdlh8b_Dhanurmasa%20-%20month%20of%20mudgannam%20%28pongal%29.webp"
            alt="Dhanurmasa - month of mudgannam (Pongal)"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
        
        <div className="mt-8 text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_devaswom-preview/artifacts/z19b4rfq_1000004667.png"
            alt="Makar Maasa special vazhipadu"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>
      </div>
    </div>
  </div>
);

export default VazhibaduSevas;
